export default "__VITE_PUBLIC_ASSET__bd37befe__"